export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  USER_NAME: 'userName',
  IS_EMPLOYEE: 'IsEmployee',
  MOBILE: 'mobile',
  SUPPLIER_ID: 'supplier_id',
  EMP_CODE: 'emp_code',
  EMP_ID: 'emp_id',
};
